import React, { useState, useEffect } from "react";
import { global } from "../../App/routes";
import { Link } from "react-router-dom";
import BLInput from "../../utils/components/BLInput";
import BLButton from "../../utils/components/BLButton";
import API, { headers } from "../../utils/API";
import { handleErrors, validateInput } from "../../utils/helper";
import contactSubjects from "../../utils/db/contact_subjects.json";
import BLDropdown from "../../utils/components/BLDropdown";
import contactInfo from "../../utils/db/contactInfo";
import BLCheckbox from "../../utils/components/BLCheckbox";
import { CSSTransition } from "react-transition-group";
import BLModal from "../../utils/components/BLModal";
import SEO from "../../utils/components/SEO";

export const Contact = (props) => {
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [isFormOkay, setIsFormOkay] = useState(false);
  const [isFormSending, setIsFormSending] = useState(false);
  const [response, setResponse] = useState("");
  const [agreement, setAgreement] = useState(false);
  const [agreementContent, setAgreementContent] = useState("");
  const [isAgreementIn, setIsAgreementIn] = useState(false);

  useEffect(() => {
    API.get(
      `legals/${props.translate("static_pages.contact.agreement_slug")}`,
      {
        headers: { ...headers, "Accept-Language": props.lang },
      }
    )
      .then(({ data: r }) => {
        setAgreementContent(r.data?.content || "");
      })
      .catch((err) => handleErrors(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      fullname !== "" &&
      email !== "" &&
      validateInput("email", email).success &&
      subject !== "" &&
      message !== "" &&
      agreement
    )
      setIsFormOkay(true);
    else setIsFormOkay(false);
  }, [fullname, email, subject, message, agreement]);

  const handleSubmit = (e) => {
    e.preventDefault();

    setIsFormSending(true);

    if (
      fullname === "" ||
      email === "" ||
      !validateInput("email", email).success ||
      subject === "" ||
      message === "" ||
      !agreement
    )
      return false;

    const params = {
      name: fullname,
      email,
      subject,
      message,
    };

    API.post("contact", params, {
      headers: { ...headers },
    })
      .then((response) => {
        setResponse(response.data.info.message);
        setFullname("");
        setEmail("");
        setSubject("");
        setMessage("");
        setIsFormSending(false);
      })
      .catch((err) => {
        handleErrors(err);
        setIsFormSending(false);
      });
  };

  return (
    <div className="contact-us-page">
      <SEO
        title={props.translate("static_pages.sidebar.contact")}
        description={props.translate("page_description.contactUs")}
      />
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="left-side">
              <Link
                to={global.helpCenter.links[props.lang]}
                className="help-center-link d-flex justify-content-start align-items-center"
              >
                <span className="icon">
                  <svg
                    width="72"
                    height="72"
                    viewBox="0 0 72 72"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M36 72C55.8823 72 72 55.8823 72 36C72 16.1177 55.8823 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72Z"
                      fill="url(#paint0_linear)"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M55.839 52.1287L53.0243 43.9373C54.3781 41.2007 55.0941 38.1504 55.0989 35.0812C55.1071 29.7959 53.0621 24.7983 49.3405 21.0093C45.6184 17.2196 40.6584 15.0865 35.3744 15.0027C32.606 14.9582 29.9197 15.4683 27.386 16.5171C24.9423 17.5287 22.7508 18.9941 20.8724 20.8724C18.994 22.7507 17.5287 24.9422 16.5171 27.3859C15.4683 29.9196 14.9588 32.6073 15.0026 35.3743C15.0863 40.6582 17.2195 45.6182 21.0092 49.3404C24.7908 53.0546 29.7756 55.099 35.0496 55.0989H35.0811C38.1504 55.0941 41.2006 54.3781 43.9373 53.0243L52.1288 55.839C52.4438 55.9472 52.7667 56 53.0861 56C53.8447 56 54.5827 55.702 55.1423 55.1422C55.9374 54.3471 56.2045 53.1924 55.839 52.1287ZM34.8521 44.0482C34.2163 44.0482 33.6073 44.6072 33.6367 45.2636C33.6661 45.9221 34.1707 46.479 34.8521 46.479C35.4878 46.479 36.0969 45.92 36.0675 45.2636C36.038 44.6051 35.5335 44.0482 34.8521 44.0482ZM28.8049 31.271C28.8049 27.9366 31.5177 25.2239 34.8521 25.2239C38.1865 25.2239 40.8992 27.9366 40.8992 31.271C40.8992 34.1892 38.8213 36.6312 36.0675 37.1953V41.0598C36.0675 41.7312 35.5233 42.2753 34.8521 42.2753C34.1809 42.2753 33.6367 41.7311 33.6367 41.0599V36.1027C33.6367 35.4315 34.1809 34.8873 34.8521 34.8873C36.846 34.8873 38.4684 33.265 38.4684 31.271C38.4684 29.2771 36.846 27.6548 34.8521 27.6548C32.8581 27.6548 31.2358 29.2771 31.2358 31.271C31.2358 31.9422 30.6916 32.4864 30.0204 32.4864C29.3492 32.4864 28.8049 31.9422 28.8049 31.271Z"
                      fill="white"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear"
                        x1="169.158"
                        y1="16.8221"
                        x2="16.6247"
                        y2="-83.9976"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#FEB984" />
                        <stop offset="1" stopColor="#E75B2B" />
                      </linearGradient>
                    </defs>
                  </svg>
                </span>
                <span className="title d-flex justify-content-start align-items-center">
                  {props.translate("footer.nav.help_center")}
                  <svg
                    width="8"
                    height="13"
                    viewBox="0 0 8 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.4 0.800781L7 6.40078L1.4 12.0008"
                      stroke="black"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </Link>
              <dl className="address-area">
                <dt>{props.translate("global.address")}:</dt>
                <dd className="selectable">{contactInfo.address}</dd>
                <dt>{props.translate("global.email")}:</dt>
                <dd className="selectable">
                  <a href={`mailto:${contactInfo.email}`}>
                    {contactInfo.email}
                  </a>
                </dd>
                <dt>
                  {props.translate("static_pages.contact.working_hours")}:
                </dt>
                <dd className="selectable">
                  <p className="mb-1">
                    {props.translate("global.weekdays")}:{" "}
                    {contactInfo.workingHoursWeekdays}
                  </p>
                  <p>
                    {props.translate("global.weekends")}:{" "}
                    {contactInfo.workingHoursWeekends ||
                      props.translate("global.closed")}
                  </p>
                </dd>
              </dl>
              <p className="asterisk">
                {props.translate("static_pages.contact.online_chat_text")}
              </p>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="right-side">
              <h3 className="title d-flex justify-content-start align-items-center">
                {props.translate("static_pages.contact.title")}
              </h3>
              <form action="#" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col">
                    <BLInput
                      type="text"
                      name="fullname"
                      label={props.translate("global.full_name")}
                      changed={(e) => setFullname(e.target.value)}
                      value={fullname}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <BLInput
                      type="email"
                      name="email"
                      label={props.translate("global.email")}
                      changed={(e) => setEmail(e.target.value)}
                      validationType="email"
                      value={email}
                      inputProps={{ inputMode: "email" }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <BLDropdown
                      type="text"
                      name="subject"
                      placeholder={props.translate(
                        "static_pages.contact.subject"
                      )}
                      setValue={(value) => setSubject(value)}
                      default={subject}
                      options={contactSubjects.map(({ id, title }) => ({
                        value: String(id),
                        name: props.translate(
                          `static_pages.contact.subjects.${title}`
                        ),
                      }))}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <BLInput
                      type="textarea"
                      name="message"
                      label={props.translate("static_pages.contact.message")}
                      changed={(e) => setMessage(e.target.value)}
                      value={message}
                    />
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col">
                    <BLCheckbox
                      name="agreement"
                      checked={agreement}
                      changed={(e) => setAgreement(e.target.checked)}
                      label={props.translate(
                        "global.read_and_understood_agreement",
                        {
                          link: (
                            <span
                              className="link"
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();

                                setIsAgreementIn(true);
                              }}
                              role="button"
                            >
                              {props.translate(
                                "global.contact_form_clarification_text"
                              )}
                            </span>
                          ),
                        }
                      )}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <BLButton
                      type="sec"
                      action="submit"
                      classes="w-100"
                      disabled={!isFormOkay || isFormSending}
                    >
                      {props.translate("global.send")}
                    </BLButton>
                  </div>
                  <div className="col">{response}</div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <CSSTransition
        in={isAgreementIn && agreementContent !== ""}
        timeout={300}
        classNames="bl-modal"
        unmountOnExit
      >
        <BLModal
          handleCloseModal={() => setIsAgreementIn(false)}
          headerFix={true}
        >
          <div className="modal-content-holder overflow-auto">
            <div
              className="contract-content"
              dangerouslySetInnerHTML={{ __html: agreementContent }}
            />
          </div>
        </BLModal>
      </CSSTransition>
    </div>
  );
};
